import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProyecto, updateEstadoProy, crearTarea, updateTarea, createOrdenTrabajo, updateOrdenTrabajo, createSolicitudCompra, updateSolicitudCompra, getSolicitudCompra, updateEstadoSC } from '../services/api';

// Ícono lápiz monocromático (misma línea visual que el resto de la app)
const IcLapiz = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);
import api from '../services/api';

const ESTADOS_PROY  = ['activo','en_progreso','pausado','completado','cancelado'];
const ESTADOS_TAREA = ['pendiente','en_progreso','completada'];
const ESTADOS_SC    = ['pendiente','aprobada','rechazada','convertida'];
const PRIO = ['alta','media','baja'];
const PC = { alta:'#ef4444', media:'#f59e0b', baja:'#10b981' };
const EP = { activo:'#10b981', en_progreso:'#3b82f6', pausado:'#f59e0b', completado:'#8b5cf6', cancelado:'#ef4444' };
const ET = { pendiente:'#94a3b8', en_progreso:'#3b82f6', completada:'#10b981' };
const ESC = { pendiente:'#f59e0b', aprobada:'#10b981', rechazada:'#ef4444', convertida:'#8b5cf6' };
const EPR = { baja:'#64748b', media:'#3b82f6', alta:'#f59e0b', urgente:'#ef4444' };
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const INIT_SC = { prioridad:'media', notas:'', items:[{ descripcion:'', cantidad:1, unidad:'und', precio_estimado:0 }] };

export default function DetalleProyecto() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [proyecto, setProyecto] = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [modal,    setModal]    = useState(null); // 'tarea' | 'ot' | 'sc'
  const [saving,   setSaving]   = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [formTarea, setFormTarea] = useState({ titulo:'', descripcion:'', prioridad:'media', asignado_a:'', fecha_limite:'' });
  const [editTareaId, setEditTareaId] = useState(null); // null = crear, id = editar
  const [editOTId, setEditOTId] = useState(null);
  const [editSCId, setEditSCId] = useState(null);
  const [formOT,    setFormOT]   = useState({ titulo:'', descripcion:'', prioridad:'media', tecnico_id:'', fecha_inicio:'', fecha_cierre:'' });
  const [formSC,    setFormSC]   = useState(INIT_SC);

  const load = () => {
    setLoading(true);
    getProyecto(id)
      .then(r => setProyecto(r.data))
      .catch(() => navigate('/proyectos'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    api.get('/auth/usuarios').catch(() => {});
  }, [id]);

  const cambiarEstado = async (estado) => {
    await updateEstadoProy(id, estado);
    load();
  };

  const TAREA_VACIA = { titulo:'', descripcion:'', prioridad:'media', asignado_a:'', fecha_limite:'' };
  const abrirNuevaTarea = () => { setEditTareaId(null); setFormTarea(TAREA_VACIA); setModal('tarea'); };
  const abrirEditarTarea = (t) => {
    setEditTareaId(t.id);
    setFormTarea({
      titulo: t.titulo || '',
      descripcion: t.descripcion || '',
      prioridad: t.prioridad || 'media',
      asignado_a: t.asignado_a || '',
      fecha_limite: t.fecha_limite ? String(t.fecha_limite).slice(0,10) : '',
    });
    setModal('tarea');
  };
  const cerrarTarea = () => { setModal(null); setEditTareaId(null); setFormTarea(TAREA_VACIA); };

  const handleSaveTarea = async () => {
    if (!formTarea.titulo) return alert('Título requerido');
    setSaving(true);
    try {
      if (editTareaId) await updateTarea(editTareaId, formTarea);
      else             await crearTarea(id, formTarea);
      cerrarTarea();
      load();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const OT_VACIA = { titulo:'', descripcion:'', prioridad:'media', tecnico_id:'', fecha_inicio:'', fecha_cierre:'' };
  const abrirNuevaOT = () => { setEditOTId(null); setFormOT(OT_VACIA); setModal('ot'); };
  const abrirEditarOT = (ot) => {
    setEditOTId(ot.id);
    setFormOT({
      titulo: ot.titulo || '',
      descripcion: ot.descripcion || '',
      prioridad: ot.prioridad || 'media',
      tecnico_id: ot.tecnico_id || '',
      fecha_inicio: ot.fecha_inicio ? String(ot.fecha_inicio).slice(0,10) : '',
      fecha_cierre: ot.fecha_cierre ? String(ot.fecha_cierre).slice(0,10) : '',
    });
    setModal('ot');
  };
  const cerrarOT = () => { setModal(null); setEditOTId(null); setFormOT(OT_VACIA); };

  const handleSaveOT = async () => {
    if (!formOT.titulo) return alert('Título requerido');
    setSaving(true);
    try {
      if (editOTId) await updateOrdenTrabajo(editOTId, formOT);
      else          await createOrdenTrabajo({ ...formOT, proyecto_id: id });
      cerrarOT();
      load();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const addItemSC    = () => setFormSC(f => ({ ...f, items:[...f.items, { descripcion:'', cantidad:1, unidad:'und', precio_estimado:0 }] }));
  const removeItemSC = i  => setFormSC(f => ({ ...f, items: f.items.filter((_,idx) => idx !== i) }));
  const updateItemSC = (i,k,v) => setFormSC(f => ({ ...f, items: f.items.map((it,idx) => idx===i ? {...it,[k]:v} : it) }));

  const abrirNuevaSC = () => { setEditSCId(null); setFormSC(INIT_SC); setModal('sc'); };
  const abrirEditarSC = async (sc) => {
    setEditSCId(sc.id);
    setFormSC({ prioridad: sc.prioridad || 'media', notas: sc.notas || '', items:[{ descripcion:'', cantidad:1, unidad:'und', precio_estimado:0 }] });
    setModal('sc');
    try {
      const { data } = await getSolicitudCompra(sc.id);
      const items = (data.items || []).map(it => ({
        descripcion: it.descripcion || '', cantidad: it.cantidad ?? 1,
        unidad: it.unidad || 'und', precio_estimado: it.precio_estimado ?? 0,
      }));
      setFormSC({ prioridad: data.prioridad || 'media', notas: data.notas || '',
        items: items.length ? items : [{ descripcion:'', cantidad:1, unidad:'und', precio_estimado:0 }] });
    } catch (e) { /* deja el header cargado; ítems se pueden reingresar */ }
  };
  const cerrarSC = () => { setModal(null); setEditSCId(null); setFormSC(INIT_SC); };

  const handleSaveSC = async () => {
    if (!formSC.items.some(i => i.descripcion.trim())) return alert('Agregue al menos un ítem');
    setSaving(true);
    try {
      if (editSCId) await updateSolicitudCompra(editSCId, formSC);
      else          await createSolicitudCompra({ ...formSC, proyecto_id: id });
      cerrarSC(); load();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const actualizarTarea = async (tareaId, estado) => {
    await api.patch(`/proyectos/tareas/${tareaId}/estado`, { estado });
    load();
  };

  if (loading) return <div style={{ color:'#64748b', textAlign:'center', padding:60 }}>Cargando...</div>;
  if (!proyecto) return null;

  const tareas      = proyecto.tareas || [];
  const ots         = proyecto.ordenes_trabajo || [];
  const solicitudes = proyecto.solicitudes_compra || [];
  const tareasCompletadas = tareas.filter(t => t.estado === 'completada').length;
  const avance = tareas.length ? Math.round((tareasCompletadas / tareas.length) * 100) : 0;

  return (
    <div>
      {/* Header */}
      <div style={s.header}>
        <div>
          <button style={s.backBtn} onClick={() => navigate('/proyectos')}>← Proyectos</button>
          <div style={s.proyTop}>
            <span style={s.codigo}>{proyecto.codigo}</span>
            <span style={{ ...s.badge, background:EP[proyecto.estado]+'22', color:EP[proyecto.estado] }}>{proyecto.estado}</span>
          </div>
          <h1 style={s.h1}>{proyecto.nombre}</h1>
          <p style={s.sub}>{proyecto.cliente_nombre}</p>
        </div>
        <div style={s.headerRight}>
          <select style={s.estadoSelect} value={proyecto.estado} onChange={e => cambiarEstado(e.target.value)}>
            {ESTADOS_PROY.map(e => <option key={e} value={e}>{e}</option>)}
          </select>
        </div>
      </div>

      {/* Info cards */}
      <div style={s.infoGrid}>
        <div style={s.infoCard}><p style={s.infoLabel}>Responsable</p><p style={s.infoVal}>{proyecto.responsable_nombre || '—'}</p></div>
        <div style={s.infoCard}><p style={s.infoLabel}>Presupuesto</p><p style={s.infoVal}>{proyecto.presupuesto ? fmt(proyecto.presupuesto) : '—'}</p></div>
        <div style={s.infoCard}><p style={s.infoLabel}>Inicio</p><p style={s.infoVal}>{proyecto.fecha_inicio ? new Date(proyecto.fecha_inicio).toLocaleDateString('es-CO') : '—'}</p></div>
        <div style={s.infoCard}><p style={s.infoLabel}>Fin estimado</p><p style={s.infoVal}>{proyecto.fecha_fin_estimada ? new Date(proyecto.fecha_fin_estimada).toLocaleDateString('es-CO') : '—'}</p></div>
        <div style={{ ...s.infoCard, gridColumn:'span 2' }}>
          <p style={s.infoLabel}>Avance de tareas — {avance}%</p>
          <div style={s.progressBg}><div style={{ ...s.progressBar, width:`${avance}%` }} /></div>
          <p style={{ color:'#64748b', fontSize:12, margin:'6px 0 0' }}>{tareasCompletadas} de {tareas.length} completadas</p>
        </div>
      </div>

      {proyecto.descripcion && (
        <div style={s.descCard}><p style={s.infoLabel}>Descripción</p><p style={{ color:'#cbd5e1', fontSize:13, margin:0 }}>{proyecto.descripcion}</p></div>
      )}

      {/* Tareas */}
      <div style={s.section}>
        <div style={s.sectionHeader}>
          <h2 style={s.sectionTitle}>Tareas ({tareas.length})</h2>
          <button style={s.btnPrimary} onClick={abrirNuevaTarea}>+ Nueva tarea</button>
        </div>
        {tareas.length === 0
          ? <div style={s.empty}>Sin tareas — crea la primera</div>
          : (
            <div style={s.tareasList}>
              {tareas.map(t => (
                <div key={t.id} style={{ ...s.tareaCard, borderLeft:`3px solid ${ET[t.estado]}` }}>
                  <div style={s.tareaTop}>
                    <div>
                      <p style={{ ...s.tareaTitle, textDecoration: t.estado === 'completada' ? 'line-through' : 'none', color: t.estado === 'completada' ? '#475569' : '#f1f5f9' }}>{t.titulo}</p>
                      {t.descripcion && <p style={s.tareaSub}>{t.descripcion}</p>}
                    </div>
                    <div style={s.tareaRight}>
                      <span style={{ ...s.badge, background:PC[t.prioridad]+'22', color:PC[t.prioridad], marginRight:8 }}>{t.prioridad}</span>
                      <select style={s.smallSelect} value={t.estado} onChange={e => actualizarTarea(t.id, e.target.value)}>
                        {ESTADOS_TAREA.map(e => <option key={e} value={e}>{e}</option>)}
                      </select>
                      <button style={s.iconBtn} title="Editar tarea" onClick={() => abrirEditarTarea(t)}><IcLapiz /></button>
                    </div>
                  </div>
                  <div style={s.tareaMeta}>
                    {t.asignado_nombre && <span>👤 {t.asignado_nombre}</span>}
                    {t.fecha_limite && <span>📅 {new Date(t.fecha_limite).toLocaleDateString('es-CO')}</span>}
                  </div>
                </div>
              ))}
            </div>
          )
        }
      </div>

      {/* Órdenes de Trabajo */}
      <div style={s.section}>
        <div style={s.sectionHeader}>
          <h2 style={s.sectionTitle}>Órdenes de Trabajo ({ots.length})</h2>
          <button style={s.btnSecondary} onClick={abrirNuevaOT}>+ Nueva OT</button>
        </div>
        {ots.length === 0
          ? <div style={s.empty}>Sin órdenes de trabajo para este proyecto</div>
          : (
            <div style={s.card}>
              <table style={s.table}>
                <thead><tr>{['Número','Título','Prioridad','Estado','F. Inicio','Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {ots.map(ot => (
                    <tr key={ot.id}>
                      <td style={{ ...s.td, color:'#93c5fd' }}>{ot.numero}</td>
                      <td style={s.td}>{ot.titulo}</td>
                      <td style={s.td}><span style={{ ...s.badge, background:PC[ot.prioridad]+'22', color:PC[ot.prioridad] }}>{ot.prioridad}</span></td>
                      <td style={s.td}><span style={s.badge}>{ot.estado}</span></td>
                      <td style={s.td}>{ot.fecha_inicio ? new Date(ot.fecha_inicio).toLocaleDateString('es-CO') : '—'}</td>
                      <td style={s.td}><button style={s.iconBtn} title="Editar OT" onClick={() => abrirEditarOT(ot)}><IcLapiz /></button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      </div>

      {/* Solicitudes de Compra */}
      <div style={s.section}>
        <div style={s.sectionHeader}>
          <h2 style={s.sectionTitle}>📋 Solicitudes de Compra ({solicitudes.length})</h2>
          <button style={s.btnPrimary} onClick={abrirNuevaSC}>+ Nueva solicitud</button>
        </div>
        {solicitudes.length === 0
          ? <div style={s.empty}>Sin solicitudes de compra para este proyecto</div>
          : (
            <div style={s.card}>
              <table style={s.table}>
                <thead><tr>{['Número','Prioridad','Estado','Solicitante','Fecha','Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {solicitudes.map(sc => (
                    <tr key={sc.id}>
                      <td style={{ ...s.td, color:'#93c5fd', fontWeight:600 }}>{sc.numero}</td>
                      <td style={s.td}><span style={{ ...s.badge, background:EPR[sc.prioridad]+'22', color:EPR[sc.prioridad] }}>{sc.prioridad}</span></td>
                      <td style={s.td}>
                        <select style={s.smallSelect} value={sc.estado}
                          onChange={e => updateEstadoSC(sc.id, e.target.value).then(load)}>
                          {ESTADOS_SC.map(e => <option key={e} value={e}>{e}</option>)}
                        </select>
                      </td>
                      <td style={s.td}>{sc.solicitante_nombre || '—'}</td>
                      <td style={s.td}>{new Date(sc.created_at).toLocaleDateString('es-CO')}</td>
                      <td style={s.td}>
                        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                          <button style={s.iconBtn} title="Editar solicitud" onClick={() => abrirEditarSC(sc)}><IcLapiz /></button>
                          {sc.notas && <span style={{ color:'#64748b', fontSize:11 }} title={sc.notas}>{sc.notas.substring(0,30)}{sc.notas.length>30?'…':''}</span>}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      </div>

      {/* Modal tarea */}
      {modal === 'tarea' && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>{editTareaId ? 'Editar Tarea' : 'Nueva Tarea'}</h2><button style={s.closeBtn} onClick={cerrarTarea}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.field}><label style={s.label}>Título *</label><input style={s.input} value={formTarea.titulo} onChange={e => setFormTarea({...formTarea, titulo:e.target.value})} /></div>
              <div style={s.field}><label style={s.label}>Descripción</label><textarea style={{ ...s.input, minHeight:60, resize:'vertical' }} value={formTarea.descripcion} onChange={e => setFormTarea({...formTarea, descripcion:e.target.value})} /></div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Prioridad</label>
                  <select style={s.input} value={formTarea.prioridad} onChange={e => setFormTarea({...formTarea, prioridad:e.target.value})}>
                    {PRIO.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Fecha límite</label><input style={s.input} type="date" value={formTarea.fecha_limite} onChange={e => setFormTarea({...formTarea, fecha_limite:e.target.value})} /></div>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={cerrarTarea}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity:saving?0.7:1 }} onClick={handleSaveTarea} disabled={saving}>{saving ? 'Guardando...' : (editTareaId ? 'Guardar cambios' : 'Crear tarea')}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal SC */}
      {modal === 'sc' && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:700 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>{editSCId ? 'Editar Solicitud de Compra' : 'Nueva Solicitud de Compra'}</h2><button style={s.closeBtn} onClick={cerrarSC}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Prioridad</label>
                  <select style={s.input} value={formSC.prioridad} onChange={e => setFormSC({...formSC, prioridad:e.target.value})}>
                    {['baja','media','alta','urgente'].map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Notas / Justificación</label>
                  <input style={s.input} value={formSC.notas} onChange={e => setFormSC({...formSC, notas:e.target.value})} placeholder="¿Por qué se necesita?" />
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
                <label style={s.label}>Ítems a solicitar</label>
                <button style={{ background:'#1e40af', color:'#93c5fd', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' }} onClick={addItemSC}>+ Agregar</button>
              </div>
              {formSC.items.map((it, i) => (
                <div key={i} style={{ display:'flex', gap:8, alignItems:'center', marginBottom:8 }}>
                  <input style={{ ...s.input, flex:3 }} placeholder="Descripción" value={it.descripcion} onChange={e => updateItemSC(i,'descripcion',e.target.value)} />
                  <input style={{ ...s.input, flex:1 }} type="number" placeholder="Cant." value={it.cantidad} onChange={e => updateItemSC(i,'cantidad',e.target.value)} />
                  <input style={{ ...s.input, flex:1 }} placeholder="Und" value={it.unidad} onChange={e => updateItemSC(i,'unidad',e.target.value)} />
                  <input style={{ ...s.input, flex:2 }} type="number" placeholder="Precio est." value={it.precio_estimado} onChange={e => updateItemSC(i,'precio_estimado',e.target.value)} />
                  {formSC.items.length > 1 && <button style={{ background:'#450a0a', border:'none', color:'#fca5a5', borderRadius:6, padding:'4px 8px', cursor:'pointer' }} onClick={() => removeItemSC(i)}>✕</button>}
                </div>
              ))}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={cerrarSC}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity:saving?0.7:1 }} onClick={handleSaveSC} disabled={saving}>{saving ? 'Guardando...' : (editSCId ? 'Guardar cambios' : 'Crear solicitud')}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal OT */}
      {modal === 'ot' && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>{editOTId ? 'Editar Orden de Trabajo' : 'Nueva Orden de Trabajo'}</h2><button style={s.closeBtn} onClick={cerrarOT}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.field}><label style={s.label}>Título *</label><input style={s.input} value={formOT.titulo} onChange={e => setFormOT({...formOT, titulo:e.target.value})} /></div>
              <div style={s.field}><label style={s.label}>Descripción</label><textarea style={{ ...s.input, minHeight:60, resize:'vertical' }} value={formOT.descripcion} onChange={e => setFormOT({...formOT, descripcion:e.target.value})} /></div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Prioridad</label>
                  <select style={s.input} value={formOT.prioridad} onChange={e => setFormOT({...formOT, prioridad:e.target.value})}>
                    {PRIO.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Fecha inicio</label><input style={s.input} type="date" value={formOT.fecha_inicio} onChange={e => setFormOT({...formOT, fecha_inicio:e.target.value})} /></div>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={cerrarOT}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity:saving?0.7:1 }} onClick={handleSaveOT} disabled={saving}>{saving ? 'Guardando...' : (editOTId ? 'Guardar cambios' : 'Crear OT')}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  header:      { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24 },
  backBtn:     { background:'transparent', border:'none', color:'#64748b', cursor:'pointer', fontSize:13, padding:'0 0 8px', display:'block' },
  proyTop:     { display:'flex', alignItems:'center', gap:10, marginBottom:6 },
  codigo:      { color:'#3b82f6', fontSize:13, fontWeight:600 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  headerRight: { display:'flex', flexDirection:'column', alignItems:'flex-end', gap:10 },
  estadoSelect:{ background:'#1e293b', border:'1px solid #334155', color:'#f1f5f9', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  infoGrid:    { display:'grid', gridTemplateColumns:'repeat(6,1fr)', gap:12, marginBottom:16 },
  infoCard:    { background:'#1e293b', borderRadius:10, padding:'14px 18px', border:'1px solid #334155' },
  infoLabel:   { color:'#64748b', fontSize:11, textTransform:'uppercase', letterSpacing:.8, margin:'0 0 6px' },
  infoVal:     { color:'#f1f5f9', fontSize:15, fontWeight:600, margin:0 },
  progressBg:  { background:'#0f172a', borderRadius:4, height:8, overflow:'hidden' },
  progressBar: { background:'#3b82f6', height:'100%', borderRadius:4, transition:'width .3s' },
  descCard:    { background:'#1e293b', borderRadius:10, padding:'16px 20px', border:'1px solid #334155', marginBottom:20 },
  badge:       { padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 },
  section:     { marginBottom:28 },
  sectionHeader:{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 },
  sectionTitle: { color:'#f1f5f9', fontSize:16, fontWeight:600, margin:0 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'8px 18px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'8px 18px', fontSize:13, cursor:'pointer' },
  empty:       { color:'#475569', fontSize:13, textAlign:'center', padding:'28px', background:'#1e293b', borderRadius:10, border:'1px solid #334155' },
  tareasList:  { display:'flex', flexDirection:'column', gap:8 },
  tareaCard:   { background:'#1e293b', borderRadius:10, padding:'14px 18px', border:'1px solid #334155' },
  tareaTop:    { display:'flex', justifyContent:'space-between', alignItems:'flex-start' },
  tareaTitle:  { fontSize:14, fontWeight:500, margin:'0 0 2px' },
  tareaSub:    { color:'#64748b', fontSize:12, margin:0 },
  tareaRight:  { display:'flex', alignItems:'center', flexShrink:0, marginLeft:12 },
  iconBtn:     { display:'inline-flex', alignItems:'center', justifyContent:'center', background:'transparent', color:'#94a3b8', border:'1px solid #334155', borderRadius:6, padding:'4px 6px', cursor:'pointer' },
  tareaMeta:   { display:'flex', gap:16, color:'#64748b', fontSize:12, marginTop:8 },
  smallSelect: { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:6, padding:'3px 8px', fontSize:12, cursor:'pointer' },
  card:        { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  table:       { width:'100%', borderCollapse:'collapse' },
  th:          { padding:'12px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032' },
  td:          { padding:'12px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332' },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:560, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px', overflowY:'auto', flex:1 },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
};
